export default __webpack_public_path__ + "113404082335d0c12c9675a7d6d69e41.svg";